module.exports = __webpack_public_path__ + "media/icons/pochodzenie-polska-blue@3x-402f1cbb.svg";